import * as React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';
import type { InjectedFormProps } from 'redux-form';
import { Field, getFormValues } from 'redux-form';

import { FileType } from '@acceligentllc/shared/enums/fileType';

import type { RootState } from 'af-reducers';

import { fromFileType } from 'ab-enums/mimeType.enum';

import { COMPANY_POLICY } from 'af-constants/reduxForms';

import { Button } from '@acceligentllc/storybook';

import type { CompanyPolicyFM } from '../formModel';
import FileInput from './FileInput';
import styles from './styles.module.scss';

type Props = ConnectedProps<typeof connector> & InjectedFormProps<CompanyPolicyFM>;

const CompanyPolicyForm: React.FC<Props> = (props) => {

	const { change: _change, fileName } = props;

	const inputRef = React.useRef<HTMLInputElement>(null);

	const change = React.useMemo(() => {
		return _change;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onInputClick = React.useCallback(() => {
		inputRef.current?.click();
	}, []);

	const deleteFile = React.useCallback(() => {
		change('files', []);
		change('fileName', null);
		change('deleteFile', true);
	}, [change]);

	const changeFile = React.useCallback((files: File[]) => {
		change('files', files);
		change('fileName', files[0].name);
		change('deleteFile', false);
	}, [change]);

	const renderFileInput = React.useCallback(() => {
		return (
			<FileInput
				acceptFileTypes={fromFileType(FileType.PDF) ?? ''}
				onFileChange={changeFile}
				ref={inputRef}
			/>
		);
	}, [changeFile]);

	return (
		<Form>
			<Row>
				<Col sm={8}>
					<div className={styles.container}>
						<Button
							icon="ActionImport"
							onClick={onInputClick}
							style="secondary"
							tooltip="Upload"
							tooltipPosition="bottom"
						/>
						<Button
							disabled={!fileName}
							icon="Delete"
							onClick={deleteFile}
							style="danger"
							tooltip="Delete"
							tooltipPosition="bottom"
						/>
						<Field
							component={renderFileInput}
							name="files"
							withRef
						/>
						<div className={styles.fileName}>
							{fileName ?? <div>Upload a file</div>}
						</div>
					</div>
				</Col>
			</Row>
		</Form>
	);
};

function mapStateToProps(state: RootState) {
	const currentFormValues = getFormValues(COMPANY_POLICY)(state) as CompanyPolicyFM;

	return {
		fileName: currentFormValues?.fileName ?? null,
	};
}

const connector = connect(mapStateToProps, null);

const enhance = compose<React.ComponentClass>(
	React.memo,
	connector
);

export default enhance(CompanyPolicyForm);
